export const ALLOWED_GUESSES_CNT = 4